export default __webpack_public_path__ + "static/champion-htf-featherweight-webfont-b25ccb09588c46b48797216d77cf76dc.woff";